import React, { Component } from "react";
import axios, { AxiosError } from "axios";
import { steps } from "../helpers/Lists.js";
import { MortgageReason } from "../helpers/Enums.js";

import { BuyOrSwitch } from "./BuyOrSwitch.tsx";
import { Purchaser } from "./Purchaser.tsx";
import { Switcher } from "./Switcher.tsx";
import { BorrowingLevel } from "./BorrowingLevel.tsx";
import { CheckingLenders } from "./CheckingLenders.tsx";
import { LenderResult } from "./LenderResult.tsx";
import { CaptureName } from "./CaptureName.tsx";
import { CaptureContactDetails } from "./CaptureContactDetails.tsx";
import { CurrentLender } from "./CurrentLender.tsx";
import { SwitcherValues } from "./SwitcherValues.tsx";
import { CurrentlyPaying } from "./CurrentlyPaying.tsx";
import { SwitcherSavingYes } from "./SwitcherSavingYes.tsx";
import { SwitcherSavingNo } from "./SwitcherSavingNo.tsx";
import { CurrentLenderTopup } from "./CurrentLenderTopup.tsx";
import { SingleOrJoint } from "./SingleOrJoint.tsx";
import { IsFirstMortgage } from "./IsFirstMortgage.tsx";
import { PaymentsAndSavings } from "./PaymentsAndSavings.tsx";
import { Income } from "./Income.tsx";
import { SwitcherStabilityYes } from "./SwitcherStabilityYes.tsx";
import { SwitcherTopupYes } from "./SwitcherTopupYes.tsx";
import { Terminator } from "./Terminator.tsx";
import { FastTrack } from "./Fasttrack.tsx";
import { TerminatorInvite } from "./TerminatorInvite.tsx";
import { SwitchingCalculator } from "./SwitchingCalculator.tsx";
import { PurchasingCalculator } from "./PurchasingCalculator.tsx";
import { ILead, ILeadCalculationResult } from "../helpers/Models.tsx";
import { InsuranceQuoteFor } from "./InsuranceQuoteFor.tsx";
import { DOB } from "./DOB.tsx";
import { Gender } from "./Gender.tsx";
import { CoverAmount } from "./CoverAmount.tsx";
import { SmokerStatus } from "./SmokerStatus.tsx";
import { CoverFor } from "./CoverFor.tsx";
import { OverpaymentCalculator } from "./OverpaymentCalculator.tsx";
import { TerminatorInsurance } from "./TerminatorInsurance.tsx";
import TagManager from "react-gtm-module";
import { SubscribeNewsletter } from "./SubscribeNewsletter.tsx";
import { UnsubscribeNewsletter } from "./UnsubscribeNewsletter.tsx";
import { LVDOB } from "./LVDOB.tsx";
import { LVDependent } from "./LVDependent.tsx";
import { LVDependentCosts } from "./LVDependentCosts.tsx";
import { LVEmploymentType } from "./LVEmploymentType.tsx";
import { LVEmploymentDetails } from "./LVEmploymentDetails.tsx";
import { LVFinancialCommitments } from "./LVFinancialCommitments.tsx";
import { LVExistingPropertyDetails } from "./LVExistingPropertyDetails.tsx";
import { SwitcherRates } from "./SwitcherRates.tsx";
import axiosRetry from "axios-retry";
import toast from "react-hot-toast";
import { ErrorBox } from "../components/ErrorBox.tsx";
import { StandardButton } from "../components/StandardButton.tsx";
interface IProps {
  startingStep: string;
  journey: string;
  showCalculators: boolean;
  gtmTag?: string;
}

interface ICrumb {
  lead: ILead;
  currentStep: string;
}

interface IState {
  lead: ILead;
  crumbs: ICrumb[];
  transition: "fade-in" | "fade-out";
  currentStep: string;
  loadJourney: boolean;
  leadCalculationResult?: ILeadCalculationResult;
  navigateTo?: string;
  showError: boolean;
}

export class MortgageApplication extends Component<IProps, IState> {
  //backListener: any;

  constructor(props: any) {
    super(props);
    const params = new URLSearchParams(window.location.search);
    var referrer = params.get("referrer");

    var leadString = localStorage.getItem("lead");
    if (leadString) {
      var lead: ILead = JSON.parse(localStorage.getItem("lead"));
      var crumbs: ICrumb[] = JSON.parse(localStorage.getItem("crumbs"));
      var currentStep: string = localStorage.getItem("currentStep");
      var leadCalculationResult: ILeadCalculationResult = JSON.parse(
        localStorage.getItem("leadCalculationResult")
      );

      this.state = {
        lead: lead,
        currentStep: currentStep,
        loadJourney: this.props.journey !== "",
        crumbs: crumbs,
        transition: "fade-in",
        showError: false,
        leadCalculationResult: leadCalculationResult,
      };
    } else {
      this.state = {
        lead: {
          currentStep: this.props.startingStep,
          consentGiven: false,
          gtmTag: "GTM-P8PCB9MZ",
          referrer: referrer ?? undefined,
        },
        currentStep: this.props.startingStep,
        loadJourney: this.props.journey !== "",
        crumbs: [],
        transition: "fade-in",
        showError: false,
      };
    }

    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.updateLead = this.updateLead.bind(this);
    this.setLenderResult = this.setLenderResult.bind(this);
    this.gtmEvent = this.gtmEvent.bind(this);
    this.onMaxRetryTimesExceededHandler =
      this.onMaxRetryTimesExceededHandler.bind(this);
    this.healthCheck = this.healthCheck.bind(this);
    this.updateStorage = this.updateStorage.bind(this);
    this.clearStorage = this.clearStorage.bind(this);
  }

  componentDidMount() {
    axiosRetry(axios, {
      retries: 3,
      retryDelay: (retryCount) => {
        return retryCount * 500;
      },
      retryCondition(error) {
        // Conditional check the error status code
        if (!error.response && error.code) {
          return true;
        }
        if (error.response && error.response.status >= 400) {
          return true;
        }
        return false; // Do not retry the others
      },
      shouldResetTimeout: true,
      onMaxRetryTimesExceeded: this.onMaxRetryTimesExceededHandler,
    });

    if ((this.props.gtmTag ?? "") !== "") {
      const tagManagerArgs = {
        gtmId: this.props.gtmTag,
      };
      TagManager.initialize(tagManagerArgs);
    }

    if (this.state.loadJourney) {
      this.nextStep(this.props.journey);
    }
    //this.onScrollNearBottom(this.scrollToLoad);

    // this.backListener = browserHistory.listen((loc) => {
    //     if (loc.action === "POP") {
    //         this.prevStep();
    //     }
    // });
  }

  updateStorage(
    lead: ILead,
    crumbs: ICrumb[],
    currentStep: string,
    leadCalculationResult?: ILeadCalculationResult
  ) {
    if (
      [
        steps.terminator,
        steps.terminator_invite,
        steps.terminator_insurance,
        steps.fasttrack,
      ].includes(currentStep)
    ) {
      this.clearStorage();
    } else {
      localStorage.setItem("lead", JSON.stringify(lead));
      localStorage.setItem("crumbs", JSON.stringify(crumbs));
      localStorage.setItem("currentStep", currentStep);
      if (leadCalculationResult) {
        localStorage.setItem(
          "leadCalculationResult",
          JSON.stringify(leadCalculationResult)
        );
      }
    }
  }

  clearStorage() {
    localStorage.removeItem("lead");
    localStorage.removeItem("crumbs");
    localStorage.removeItem("currentStep");

    this.setState({
      lead: {
        id: this.state.lead.id,
        consentGiven: false,
        currentStep: this.props.startingStep,
        gtmTag: "GTM-P8PCB9MZ",
      },
      transition: "fade-out",
      currentStep: this.props.startingStep,
    });
  }

  gtmEvent() {
    if (this.state.lead.dataLayerName) {
      const tagManagerArgsInit = {
        gtmId: this.props.gtmTag,
        events: {
          event: this.state.lead.dataLayerName,
          userId: this.state.lead.id,
          page: this.state.lead.page,
        },
      };
      TagManager.initialize(tagManagerArgsInit);
    }
  }

  componentWillUnmount() {
    // Unbind listener
    //this.backListener();
  }

  // proceed to the next step
  nextStep = (response?: string, loadJourney?: boolean, delay?: boolean) => {
    if ((delay ?? undefined) === undefined) {
      // This is a bit of a bandaid, but needed to allow some state refreshes before we post to the api
      setTimeout(() => this.nextStep(response, loadJourney, true), 100);
      return;
    }
    this.setState({ transition: "fade-out", showError: false });
    var lead: ILead = this.state.lead;

    if (!lead.journeyName) {
      if (lead.currentStep.startsWith("insurance")) {
        lead.journeyName = "Insurance Quote " + response;
      }
      if (loadJourney) {
        lead.journeyName = response;
      }
    }

    // When next step is called check if we got a lead calculation result.
    if (this.state.leadCalculationResult) {
      lead.leadCalculationResult = this.state.leadCalculationResult;
    }

    var crumbs = this.state.crumbs;
    crumbs.push({ lead: this.state.lead, currentStep: this.state.currentStep });

    lead.response = response ?? "next";

    axios
      .post("/lead", lead)
      .then((response) => {
        var lead = response.data as ILead;
        var transition = "fade-in";

        this.updateStorage(
          lead,
          crumbs,
          lead.currentStep,
          this.state.leadCalculationResult
        );

        this.setState({
          lead: lead,
          currentStep: lead.currentStep,
          transition: "fade-in",
          loadJourney: false,
          navigateTo: lead.navigateToInvite ? lead.portalLink : null,
        });
      })
      .catch((error) => {
        //alert('submit error: ' + error.message);
      });
  };

  healthCheck = () => {
    axios
      .get("/doddl/healthcheck")
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error("submit error: " + error?.message);
      });
  };

  prevStep = () => {
    var crumbs = this.state.crumbs;
    if (crumbs.length > 0) {
      var crumb = crumbs.pop();
      // If we hit the auto steps, do a double pop
      while (crumb?.currentStep === steps.checklenders) crumb = crumbs.pop();
      //var lead = this.state.lead;
      //lead.currentStep = crumb!.lead.currentStep;
      this.updateStorage(
        crumb!.lead,
        crumbs,
        crumb.currentStep,
        crumb.lead.leadCalculationResult
      );
      this.setState({
        lead: crumb!.lead,
        currentStep: crumb!.currentStep,
        crumbs: crumbs,
      });
    }
  };

  onMaxRetryTimesExceededHandler(
    _error: AxiosError<unknown, any>,
    _count: number
  ) {
    this.setState({
      loadJourney: false,
      transition: "fade-in",
      showError: true,
    });
  }

  updateLead(updatedProperties: any) {
    // Each component is responsible for updating the specific properties of the lead that are
    // relevant to that component. Simply spread the properties of the passed in object onto the state
    // (Note: first spread the previous state of lead so that we are updating it accurately)
    this.setState((prevState) => ({
      showError: false,
      lead: {
        ...prevState.lead,
        ...updatedProperties,
      },
    }));
  }

  setLenderResult(result: ILeadCalculationResult) {
    var lead = this.state.lead;
    lead.leadCalculationResult = result;

    this.setState({ lead: lead, leadCalculationResult: result });
  }

  render() {
    if (this.state.loadJourney) {
      return <div className="loading-spinner" />;
    }

    if ((this.state.navigateTo ?? "") !== "") {
      this.clearStorage();
      var loaderDiv = window.document.getElementById("loaderdiv");
      if (loaderDiv) loaderDiv.style.display = "block";
      setTimeout(() => {
        window.location.href = this.state.navigateTo;
      }, 100);
      return <></>;
    }

    var transition: string = this.state.transition;
    var headerClass = "";
    if (this.state.currentStep === "fasttrack") {
      transition += " fly-in";
      //headerClass = 'scroll-transition';
    }

    if (this.state.transition === "fade-out") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }

    var showPrev = this.props.startingStep !== this.state.currentStep;
    return (
      <>
        {this.state.transition === "fade-out" && (
          <div className="row float justify-c">
            <div className="loading-spinner" />
          </div>
        )}
        <div className={transition}>
          {this.state.showError && (
            <ErrorBox
              failure={
                <>
                  <span>Error sending your request.</span>
                  <br />
                  <br />
                  <span>Please try again or contact doddl for help</span>
                </>
              }
              errors={[]}
            />
          )}
          {this.state.currentStep === steps.buyorswitch && (
            <BuyOrSwitch
              key={this.state.currentStep}
              showCalculators={this.props.showCalculators}
              nextStep={this.nextStep}
              gtmTag={this.state.lead.gtmTag}
              healthCheck={this.healthCheck}
            />
          )}
          {this.state.currentStep === steps.purchaser && (
            <Purchaser
              showPrev={showPrev}
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.switcher && (
            <Switcher
              showPrev={showPrev}
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.borrowinglevel_looking && (
            <BorrowingLevel
              key={this.state.currentStep}
              title={
                <>Great! Let us find (and fast track) the mortgage for you</>
              }
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              mortgageAmountRequired={this.state.lead.mortgageAmountRequired}
              homeValue={this.state.lead.homeValue}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.borrowinglevel_foundhome && (
            <BorrowingLevel
              key={this.state.currentStep}
              title={
                <>Great! Let us find (and fast track) the mortgage for you</>
              }
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              mortgageAmountRequired={this.state.lead.mortgageAmountRequired}
              homeValue={this.state.lead.homeValue}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.checklenders && (
            <CheckingLenders
              key={this.state.currentStep}
              lead={this.state.lead}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              setLenderResult={this.setLenderResult}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.lenderresult && (
            <LenderResult
              key={this.state.currentStep}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              repaymentAmount={this.state.leadCalculationResult?.repayment ?? 0}
              cashback={this.state.leadCalculationResult?.cashback ?? 0}
              term={this.state.leadCalculationResult?.term ?? 0}
              rate={this.state.leadCalculationResult?.rate ?? 0}
              rateType={this.state.leadCalculationResult?.rateType ?? ""}
              fixedYears={this.state.leadCalculationResult?.fixedYears ?? 0}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.capturename && (
            <CaptureName
              key={this.state.currentStep}
              customLabel={
                this.state.lead.mortgageReason ===
                MortgageReason.ReducePayments.toString() ? (
                  <>
                    Let us send you all of the options with tailored advice to
                    you.
                  </>
                ) : null
              }
              journeyName={this.state.lead.journeyName}
              firstname={this.state.lead.firstNameApplicant1 ?? ""}
              surname={this.state.lead.surnameApplicant1 ?? ""}
              applicant={1}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.capturecontact && (
            <CaptureContactDetails
              key={this.state.currentStep}
              firstname={this.state.lead.firstNameApplicant1 ?? ""}
              email={this.state.lead.emailApplicant1 ?? ""}
              phone1={this.state.lead.phone1 ?? ""}
              consent={this.state.lead.consentGiven ?? false}
              applicant={1}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.capturename2 && (
            <CaptureName
              key={this.state.currentStep}
              journeyName={this.state.lead.journeyName}
              firstname={this.state.lead.firstNameApplicant2 ?? ""}
              surname={this.state.lead.surnameApplicant2 ?? ""}
              applicant={2}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.capturecontact2 && (
            <CaptureContactDetails
              key={this.state.currentStep}
              firstname={this.state.lead.firstNameApplicant2 ?? ""}
              email={this.state.lead.emailApplicant2 ?? ""}
              consent={this.state.lead.consentGiven ?? false}
              applicant={2}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.currentlender_reduce && (
            <CurrentLender
              key={this.state.currentStep}
              title={
                <>
                  OK, let's see
                  <br />
                  what you can save
                </>
              }
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              currentLender={this.state.lead.currentLender}
              currentBER={this.state.lead.ber}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.currentlender_lockin && (
            <CurrentLender
              key={this.state.currentStep}
              title={
                <>
                  OK, let’s see if we can
                  <br />
                  <span className="doddltext">Lock in your mortgage</span>
                </>
              }
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              currentLender={this.state.lead.currentLender}
              currentBER={this.state.lead.ber}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.currentlender_topup && (
            <CurrentLenderTopup
              key={this.state.currentStep}
              title={
                <>
                  Let’s see if we can help you
                  <br />
                  release equity out of your home
                </>
              }
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              currentLender={this.state.lead.currentLender}
              topupValue={this.state.lead.topup}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.switchervalues && (
            <SwitcherValues
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              existingMortgage={this.state.lead.existingMortgage}
              homeValue={this.state.lead.homeValue}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.currentlypaying && (
            <CurrentlyPaying
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              monthlyRepayments={this.state.lead.monthlyRepayments}
              remainingTerm={this.state.lead.remainingTerm}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.switcher_lockin_yes && (
            <SwitcherStabilityYes
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
            />
          )}
          {/* {this.state.currentStep === steps.switcher_lockin_no &&
                    <></>
                } */}
          {this.state.currentStep === steps.switcher_reduce_yes && (
            <SwitcherSavingYes
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              monthlySavings={this.state.leadCalculationResult?.savings}
              cashback={this.state.leadCalculationResult?.cashback}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.switcher_reduce_no && (
            <SwitcherSavingNo
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              cashback={this.state.leadCalculationResult?.cashback}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.switcher_topup_yes && (
            <SwitcherTopupYes
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
            />
          )}
          {/* {this.state.currentStep === steps.switcher_topup_no &&
                    <></>
                } */}
          {this.state.currentStep === steps.singleorjoint && (
            <SingleOrJoint
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.isfirstmortgage && (
            <IsFirstMortgage
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
              mortgageamount={this.state.lead.mortgageAmountRequired}
              lvretainexistingproperty={
                this.state.lead.lvretainexistingproperty
              }
            />
          )}
          {this.state.currentStep === steps.lvdependents && (
            <LVDependent
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
            />
          )}

          {this.state.currentStep === steps.lvfinancialcommitments && (
            <LVFinancialCommitments
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
              mortgageamount={this.state.lead.mortgageAmountRequired}
              consent={this.state.lead.consentGiven ?? false}
            />
          )}
          {this.state.currentStep === steps.paymentsandsavings && (
            <PaymentsAndSavings
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
              monthlySavings={this.state.lead.monthlySavings}
              rentOrMortgage={this.state.lead.monthlyRepayments}
              mortgageamount={this.state.lead.mortgageAmountRequired}
              lvloanrepayment={this.state.lead.lvloanrepayment}
              mortgageType={this.state.lead.mortgageType}
            />
          )}
          {this.state.currentStep === steps.income && (
            <Income
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              isJoint={this.state.lead.applicationType === "joint"}
              mortgageamount={this.state.lead.mortgageAmountRequired}
              isHH={this.state.lead.isFirstMortgage}
              grossIncome={this.state.lead.grossBasicIncome}
              variableIncome={this.state.lead.grossVariableIncome}
              gtmEvent={this.gtmEvent}
              consent={this.state.lead.consentGiven ?? false}
            />
          )}
          {this.state.currentStep === steps.lvdependentcost && (
            <LVDependentCosts
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              updateLead={this.updateLead}
              childcareCost={this.state.lead.lvchildcarecost}
              maintenanceCost={this.state.lead.lvmaintenancecost}
              gtmEvent={this.gtmEvent}
              consent={this.state.lead.consentGiven ?? false}
            />
          )}
          {this.state.currentStep === steps.fasttrack && (
            <FastTrack
              key={this.state.currentStep}
              name={this.state.lead.firstNameApplicant1 ?? ""}
              applicationType={this.state.lead.applicationType}
              updateLead={this.updateLead}
              email2={this.state.lead.emailApplicant2}
              gtmEvent={this.gtmEvent}
              nextStep={this.nextStep}
              contactHasProfile={this.state.lead.existing ?? false}
            />
          )}
          {this.state.currentStep === steps.terminator && (
            <Terminator
              key={this.state.currentStep}
              name={this.state.lead.firstNameApplicant1 ?? ""}
              mortgageAmount={
                this.state.lead.existingMortgage ??
                this.state.lead.mortgageAmountRequired
              }
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.terminator_invite && (
            <TerminatorInvite
              key={this.state.currentStep}
              name={this.state.lead.firstNameApplicant1 ?? ""}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.switching_calculator && (
            <SwitchingCalculator
              key={this.state.currentStep}
              nextStep={this.nextStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.purchasing_calculator && (
            <PurchasingCalculator
              key={this.state.currentStep}
              nextStep={this.nextStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.overpayment_calculator && (
            <OverpaymentCalculator
              existingMortgage={this.state.lead.existingMortgage}
              overpayBy={this.state.lead.overpayBy}
              gtmEvent={this.gtmEvent}
              nextStep={this.nextStep}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.insurance_for && (
            <InsuranceQuoteFor
              key={this.state.currentStep}
              justMe={this.state.lead.applicationType}
              nextStep={this.nextStep}
              gtmEvent={this.gtmEvent}
            />
          )}
          {
            //this.state.currentStep === steps.capturecontact2 &&
            // <CaptureNameAndDetailsFull
            //     key={this.state.currentStep}
            //     applicationType={this.state.lead.applicationType}
            //     firstname1={this.state.lead.firstNameApplicant1}
            //     surname1={this.state.lead.surnameApplicant1}
            //     email1={this.state.lead.emailApplicant1}
            //     phone1={this.state.lead.phone}
            //     firstname2={this.state.lead.firstNameApplicant2}
            //     surname2={this.state.lead.surnameApplicant2}
            //     email2={this.state.lead.emailApplicant2}
            //     nextStep={this.nextStep}
            //     prevStep={this.prevStep}
            //     gtmEvent={this.gtmEvent}
            //     updateLead={this.updateLead} />
          }
          {this.state.currentStep === steps.gender && (
            <Gender
              key={this.state.currentStep}
              applicant={1}
              gender={this.state.lead.gender1}
              firstName={this.state.lead.firstNameApplicant1}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.gender2 && (
            <Gender
              key={this.state.currentStep}
              applicant={2}
              gender={this.state.lead.gender2}
              firstName={this.state.lead.firstNameApplicant2}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.dateofbirth && (
            <DOB
              key={this.state.currentStep}
              applicant={1}
              dob={this.state.lead.dateOfBirth1}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.dob && (
            <DOB
              key={this.state.currentStep}
              applicant={1}
              dob={this.state.lead.dateOfBirth1}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.dob2 && (
            <DOB
              key={this.state.currentStep}
              applicant={2}
              dob={this.state.lead.dateOfBirth2}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.lvdob && (
            <LVDOB
              key={this.state.currentStep}
              applicant={1}
              dob={this.state.lead.dateOfBirth1}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.switcherrates && (
            <SwitcherRates
              key={this.state.currentStep}
              title={
                <>
                  Are you currently on a fixed or variable
                  <br />
                  rate mortgage?
                </>
              }
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              updateLead={this.updateLead}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.cover_for && (
            <CoverFor
              key={this.state.currentStep}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              coverFor={this.state.lead.coverFor}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.cover_amount && (
            <CoverAmount
              key={this.state.currentStep}
              coverAmount={this.state.lead.coverAmount}
              coverTerm={this.state.lead.coverTerm}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
            />
          )}
          {this.state.currentStep === steps.lvemploymenttype && (
            <LVEmploymentType
              key={this.state.currentStep}
              applicant={1}
              lvemploymenttype={this.state.lead.lvEmploymentType}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
              consent={this.state.lead.consentGiven ?? false}
              applicationType={this.state.lead.applicationType}
            />
          )}

          {this.state.currentStep === steps.lvemploymentdetails && (
            <LVEmploymentDetails
              key={this.state.currentStep}
              applicant={1}
              lvfulltimepermanent={this.state.lead.lvfulltimepermanent}
              lvprobationpassed={this.state.lead.lvprobationpassed}
              lvhowlongtrading={this.state.lead.lvhowlongtrading}
              lvEmploymentType={this.state.lead.lvEmploymentType}
              lvovertime={this.state.lead.lvovertime}
              lvshiftallowance={this.state.lead.lvshiftallowance}
              lvbonus={this.state.lead.lvbonus}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
              consent={this.state.lead.consentGiven ?? false}
              applicationType={this.state.lead.applicationType}
            />
          )}

          {this.state.currentStep === steps.lvexistingpropertydetails && (
            <LVExistingPropertyDetails
              key={this.state.currentStep}
              applicant={1}
              lvfulltimepermanent={this.state.lead.lvfulltimepermanent}
              lvprobationpassed={this.state.lead.lvprobationpassed}
              lvhowlongtrading={this.state.lead.lvhowlongtrading}
              lvemploymenttype={this.state.lead.lvEmploymentType}
              lvovertime={this.state.lead.lvovertime}
              lvshiftallowance={this.state.lead.lvshiftallowance}
              lvpropertyvalue={this.state.lead.lvpropertyvalue}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
              consent={this.state.lead.consentGiven ?? false}
              applicationType={this.state.lead.applicationType}
              lvretainexistingproperty={
                this.state.lead.lvretainexistingproperty
              }
            />
          )}
          {this.state.currentStep === steps.smoker_status && (
            <SmokerStatus
              key={this.state.currentStep}
              applicant={1}
              firstName={this.state.lead.firstNameApplicant1}
              smoker={this.state.lead.smoker}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
              consent={this.state.lead.consentGiven ?? false}
              applicationType={this.state.lead.applicationType}
            />
          )}
          {this.state.currentStep === steps.smoker_status2 && (
            <SmokerStatus
              key={this.state.currentStep}
              applicant={2}
              firstName={this.state.lead.firstNameApplicant2}
              smoker={this.state.lead.partnerSmoker}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              gtmEvent={this.gtmEvent}
              updateLead={this.updateLead}
              consent={this.state.lead.consentGiven ?? false}
              applicationType={this.state.lead.applicationType}
            />
          )}
          {this.state.currentStep === steps.terminator_insurance && (
            <TerminatorInsurance
              key={this.state.currentStep}
              name={this.state.lead.firstNameApplicant1 ?? ""}
              gtmEvent={this.gtmEvent}
            />
          )}
          {this.state.currentStep === steps.subscribe_newsletter && (
            <SubscribeNewsletter gtmEvent={this.gtmEvent} />
          )}
          {this.state.currentStep === steps.unsubscribe_newsletter && (
            <UnsubscribeNewsletter gtmEvent={this.gtmEvent} />
          )}
          <div className="row">
            <div className="button-group">
              <StandardButton
                customLabel="Start over"
                onClick={() => {
                  this.clearStorage();
                  setTimeout(
                    () => this.setState({ transition: "fade-in" }),
                    50
                  );
                }}
                type="secondary"
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
